import React, {useContext, useEffect, useRef, useState} from 'react';
import {Card, CardContent, Grid, InputAdornment, TextField} from "@mui/material";
import {blueColor, red500} from "../../../../assets/jss/main";
import {FormattedMessage, useIntl} from 'react-intl';

import SelectTitle from "../../../../components/radioGroup/SelectTitle";
import {getPriorityRulesForForm, wmsPriorityRule} from "../../../../utils/wmsPriorityRule";
import FormControlLabel from "../../../../components/radioGroup/FormControlLabel";
import RadioGroup from "../../../../components/radioGroup/RadioGroup";
import FormToggleSelection from "./FormToggleSelection";
import DrawerContent from "./DrawerContent";
import InputTextField from "../../../../components/input/new/InputTextField";
import CustomButton from "../../../../components/CustomButton";
import {createNewMission} from "../../../../api/wms/tasks/new";
import {WMSContext} from "../../context/WMSContext";
import {createNewModel} from "../../../../api/wms/wmsTaskModel/new";
import Toast from "../../../../components/WMS/Toast";
import ValidatedIcon from "../../../../assets/img/validated.svg";
import ErrorIcon from "../../../../assets/img/error.svg";
import Label from "../../../../components/input/new/Label";
import {PickingMissionModelContext} from "../PickingMissionModelContext";
import {PickingMissionModelAgeInDays} from "./PickingMissionModelAgeInDays";
import update from "api/wms/wmsTaskModel/update"
import {WMSRoutes} from "../../../../utils/WMSRoutes";
import {useHistory} from "react-router-dom";
import moment from "moment/moment";
import RightDrawerDesktop from "../../../../components/WMS/Desktop/RightDrawerDesktop";
import BottomDrawer from "../../../../components/WMS/Mobile/BottomDrawer";
import SearchBar from "../../../../components/List/components/SearchBar";
import ArrowDownIcon from "../../../../components/icons/ArrowDownIcon";
import CustomSwitch from "../../../../components/switch/CustomSwitch";

const desktopMaxWidth = "45%"

const openDrawerType = {
    ZONE: "zone",
    CARRIER: "carrier",
    PROVIDER: "provider",
    PICKER: "picker"
}

// Voluntary
const drawerTypeTraductionKey = {
    ZONE: "zone",
    CARRIER: "carrier",
    PROVIDER: "provider",
    PICKER: "picker"
}

function CreatePickingMissionForm() {
    const intl = useIntl()

    const {
        data: formData,
        editableModel,
        isEdit,
        isModel,
        isModelAuto,
        isMobile,
        init: handleResetForm,
        setIsModel,
        setIsModelAuto,
    } = useContext(PickingMissionModelContext)


    const {currentInventory, currentOrganization, currentMember} = useContext(WMSContext)

    const [missionName, setMissionName] = useState("")
    const [priorityRules, setPriorityRules] = useState([])
    const [selectedPriorityRule, setSelectedPriorityRule] = useState([])
    const [places, setPlaces] = useState()
    const [orderTypes, setOrderTypes] = useState()
    const [ages, setAges] = useState()
    const [shippingMethods, setShippingMethods] = useState()
    const [providers, setProviders] = useState()
    const [selectedProviders, setSelectedProviders] = useState([])
    const [selectedShippingMethods, setSelectedShippingMethods] = useState([])
    const [selectedPlaces, setSelectedPlaces] = useState([])
    const [quantity, setQuantity] = useState(10)
    const [runners, setRunners] = useState()
    const [selectedRunners, setSelectedRunners] = useState([])
    const [productCount, setProductCount] = useState(0)
    const [selectedItems, setSelectedItems] = useState([])
    const [isValid, setIsValid] = useState(false)
    const [openToast, setOpenToast] = useState(false)
    const [openErrorToast, setOpenErrorToast] = useState(false)
    const [numberProductError, setNumberProductError] = useState(false)

    const [loading, setLoading] = useState(false);

    const [openDrawer, setOpenDrawer] = useState(null) // NULL or STRING
    const [searchString, setSearchString] = useState("")

    const history = useHistory();
    const hasAutoSelectedRunner = useRef(false);


    const handleChangeMissionName = (value) => {
        setMissionName(value)
    }

    const handleSelectPriorityRules = (rule) => {
        setSelectedPriorityRule(priorityRules.find(priorityRule => priorityRule.value === rule))
    }

    const handleSelectRunners = (runner) => {
        if (runner.id === selectedRunners?.id) {
            handleDeselectRunner(runner)
        } else {
            let updatedRunnerList = {}
            Object.keys(runners).map(runnerId => {
                updatedRunnerList[runnerId] = {...runners[runnerId], selected: String(runnerId) === String(runner.id)}
            })
            setRunners(updatedRunnerList)
            setSelectedRunners(runner)
        }

        setOpenDrawer(null)
    }

    const handleDeselectRunner = (runner) => {
        const runnerId = typeof runner === "object" ? runner.id : runner
        setSelectedRunners([])
        setRunners({
            ...runners,
            [runnerId]: {...runners[runnerId], selected: false}
        })
    }

    const handleSelectPlace = (place) => {
        const placeId = place.id

        if (!selectedPlaces[placeId]) {
            let alreadySelectedPlaces = {...selectedPlaces}
            alreadySelectedPlaces["all"].selected = false
            alreadySelectedPlaces[placeId] = {...places[placeId], selected: true}
            setSelectedPlaces(alreadySelectedPlaces)
        } else {
            handleDeselectPlace(placeId)
        }

        setPlaces({
            ...places,
            [placeId]: {
                ...places[placeId],
                selected: !places[placeId].selected
            }
        })
    }

    const handleSelectOrderType = (orderType) => {
        const orderTypeValue = orderType.value

        setOrderTypes({
            ...orderTypes,
            [orderTypeValue]: {
                ...orderTypes[orderTypeValue],
                selected: !orderTypes[orderTypeValue].selected
            }
        })
    }

    const handleSelectAge = (age) => {
        const ageValue = age.value

        setAges({
            ...ages,
            [ageValue]: {
                ...ages[ageValue],
                selected: !ages[ageValue].selected
            }
        })
    }

    const handleSelectShippingMethods = (shippingMethod) => {
        const shippingMethodId = shippingMethod.id

        if (!selectedShippingMethods[shippingMethodId]) {
            let alreadySelectedShippingMethods = {...selectedShippingMethods}
            alreadySelectedShippingMethods["all"].selected = false
            alreadySelectedShippingMethods[shippingMethodId] = {...shippingMethods[shippingMethodId], selected: true}
            setSelectedShippingMethods(alreadySelectedShippingMethods)
        } else {
            handleDeselectShippingMethod(shippingMethodId)
        }

        setShippingMethods({
            ...shippingMethods,
            [shippingMethodId]: {
                ...shippingMethods[shippingMethodId],
                selected: !shippingMethods[shippingMethodId].selected
            }
        })
    }

    const handleSelectProvider = (provider) => {
        const providerId = provider.id

        if (!selectedProviders[providerId]) {
            let alreadySelectedProviders = {...selectedProviders}
            alreadySelectedProviders["all"].selected = false
            alreadySelectedProviders[providerId] = {...providers[providerId], selected: true}
            setSelectedProviders(alreadySelectedProviders)
        } else {
            handleDeselectProvider(providerId)
        }

        setProviders({
            ...providers,
            [providerId]: {
                ...providers[providerId],
                selected: !providers[providerId].selected
            }
        })
    }

    const handleDeselectProvider = (providerId) => {
        if (typeof providerId === "object") {
            providerId = providerId.id
        }
        if (providerId !== "all") {
            let updatedSelectedProviders = {...selectedProviders}
            delete updatedSelectedProviders[providerId]

            if (Object.keys(updatedSelectedProviders).length === 1) {
                updatedSelectedProviders["all"].selected = true
            }
            setSelectedProviders(updatedSelectedProviders)
        } else {
            // Reset providers to prevent visual bug inside the Provider drawer
            let tempProviders = {...providers}
            Object.keys(tempProviders).map(tempProviderId => {
                if ("all" !== tempProviderId) {
                    tempProviders[tempProviderId].selected = false
                }
            })

            setProviders(tempProviders)

            // Reset selectedProviders to only include "all", keeping its existing data but ensuring it is selected.
            setSelectedProviders({
                all: {
                    ...selectedProviders.all,
                    selected: true
                }
            })
        }
    }

    const handleDeselectShippingMethod = (shippingMethodId) => {
        if (typeof shippingMethodId === "object") {
            shippingMethodId = shippingMethodId.id
        }
        if (shippingMethodId !== "all") {
            let updatedSelectedShippingMethods = {...selectedShippingMethods}
            delete updatedSelectedShippingMethods[shippingMethodId]

            if (Object.keys(updatedSelectedShippingMethods).length === 1) {
                updatedSelectedShippingMethods["all"].selected = true
            }
            setSelectedShippingMethods(updatedSelectedShippingMethods)
        } else {
            // Reset shippingMethods to prevent visual bug inside the ShippingMethod drawer
            let tempShippingMethods = {...shippingMethods}
            Object.keys(tempShippingMethods).map(tempShippingMethodId => {
                if ("all" !== tempShippingMethodId) {
                    tempShippingMethods[tempShippingMethodId].selected = false
                }
            })

            setShippingMethods(tempShippingMethods)

            // Reset selectedShippingMethods to only include "all", keeping its existing data but ensuring it is selected.
            setSelectedShippingMethods({
                all: {
                    ...selectedShippingMethods.all,
                    selected: true
                }
            })
        }
    }

    const handleDeselectPlace = (placeId) => {
        if (typeof placeId === "object") {
            placeId = placeId.id
        }
        if (placeId !== "all") {
            let updatedSelectedPlaces = {...selectedPlaces}
            delete updatedSelectedPlaces[placeId]

            if (Object.keys(updatedSelectedPlaces).length === 1) {
                updatedSelectedPlaces["all"].selected = true
            }
            setSelectedPlaces(updatedSelectedPlaces)
        } else {
            // Reset places to prevent visual bug inside the Place drawer
            let tempPlaces = {...places}
            Object.keys(tempPlaces).map(tempPlaceId => {
                if ("all" !== tempPlaceId) {
                    tempPlaces[tempPlaceId].selected = false
                }
            })

            setPlaces(tempPlaces)

            // Reset selectedPlaces to only include "all", keeping its existing data but ensuring it is selected.
            setSelectedPlaces({
                all: {
                    ...selectedPlaces.all,
                    selected: true
                }
            })
        }
    }

    const getObjectData = (data) => {
        const dataKeys = Object.keys(data)
        let tempData = []
        dataKeys.map((k) => {
            tempData.push(data[k])
        })

        return tempData
    }

    const filterItem = (array1, array2) => {
        return array1.filter(item => array2.includes(item));
    }

    const orderByItemsCount = (data, count) => {
        return data.slice().sort((a, b) => {
            if (a[count] === 0 && b[count] !== 0) return 1;
            if (a[count] !== 0 && b[count] === 0) return -1;
            return b[count] - a[count];
        });
    }

    const getInitProvider = () => {
        let initToggle = {}
        let formDataProviders = formData.providers

        initToggle["all"] = formDataProviders["all"]
        initToggle["all"].name = <FormattedMessage id={"wms.newPickingMission.allProviderToggle.name"}/>

        if (isEdit) {
            let editableModelProvider = formData.isRetailerPriority ? editableModel.retailers : editableModel.brands

            if (0 < editableModelProvider.length) {
                Object.keys(formDataProviders).map(providerId => {
                    if (editableModelProvider.some(pvd => pvd.id === providerId)) {
                        formDataProviders[providerId].selected = true
                        initToggle[providerId] = formDataProviders[providerId]
                    }
                })
            }

            if (1 < Object.keys(initToggle).length) {
                initToggle["all"].selected = false
            }
        }
        return initToggle
    }

    const getInitShippingMethod = () => {
        let initToggle = {}
        let formDataShippingMethods = formData.shippingMethods

        initToggle["all"] = formDataShippingMethods["all"]
        initToggle["all"].name = <FormattedMessage id={"wms.newPickingMission.allCarrierToogle.name"}/>

        if (isEdit && editableModel) {
            if (0 < editableModel.shippingMethods.length) {
                Object.keys(formDataShippingMethods).map(shippingMethodId => {
                    if (editableModel.shippingMethods.some(method => method.id === shippingMethodId)) {
                        formDataShippingMethods[shippingMethodId].selected = true
                        initToggle[shippingMethodId] = formDataShippingMethods[shippingMethodId]
                    }
                })
            }

            if (1 < Object.keys(initToggle).length) {
                initToggle["all"].selected = false
            }
        }
        return initToggle
    }

    const getInitPlace = () => {
        let initToggle = {}
        let formDataPlaces = formatNoWmsPlaces(formData.places)

        initToggle["all"] = formDataPlaces["all"]
        initToggle["all"].name = <FormattedMessage id={"wms.newPickingMission.addPlace.label"}/>

        if (isEdit && editableModel) {
            if (0 < editableModel.wmsPlaces.length) {
                Object.keys(formDataPlaces).map(placeId => {
                    if (editableModel.wmsPlaces.some(plc => plc.id === placeId)) {
                        formDataPlaces[placeId].selected = true
                        initToggle[placeId] = formDataPlaces[placeId]
                    }
                })
            }

            if (editableModel.noWmsPlaces) {
                formDataPlaces.noWmsPlaces.selected = true
                initToggle["noWmsPlaces"] = formDataPlaces.noWmsPlaces
            }

            if (1 < Object.keys(initToggle).length) {
                initToggle["all"].selected = false
            }
        }
        return initToggle
    }

    function formatNoWmsPlaces(wmsPlaces) {
        return {
            ...wmsPlaces,
            noWmsPlaces: {
                ...wmsPlaces.noWmsPlaces,
                name: <FormattedMessage id={"wms.newPickingMission.noWmsPlacesToggle.name"}/>,
                selected: false
            }
        };
    }

    const handleChangeQuantity = (value) => {
        if (value === '') {
            setQuantity(0);
            setNumberProductError(false);
            return;
        }

        if (/^\d+$/.test(value)) {
            const numericQuantity = Number(value);
            setQuantity(numericQuantity);
            setNumberProductError(false);
        } else {
            setNumberProductError(true);
        }
    }

    const handleValid = () => {
        setLoading(true);
        if (isEdit) {
            let data = {
                name: missionName,
                auto: isModelAuto,
                inventory: currentInventory["@id"],
                maxItems: quantity,
                priorityOrder: selectedPriorityRule.value,
                noWmsPlaces: Object.keys(places).some(placeId => placeId === "noWmsPlaces" && true === places[placeId].selected),
                wmsPlaces: Object.keys(places).filter(placeId => "all" !== placeId && "noWmsPlaces" !== placeId && places[placeId].selected).map(id => `/w_m_s_places/${places[id].barcode}`),
                shippingMethods: Object.keys(shippingMethods).filter(shippingMethodId => "all" !== shippingMethodId && true === shippingMethods[shippingMethodId].selected).map(id => `/shipping_methods/${shippingMethods[id].id}`),
                isMulti: null,
                ageInDays: null,
                retailers: [],
                brands: [],
                updatedAt: moment()
            }

            const filteredProviders = Object.keys(providers).filter(providerId => true === providers[providerId].selected)

            if (!filteredProviders.some(providerId => "all" === providerId)) {
                if (true === formData.isRetailerPriority) {
                    data.retailers = filteredProviders.map(id => `/retailers/${providers[id].id}`)
                } else {
                    data.brands = filteredProviders.map(id => `/brands/${providers[id].id}`)
                }
            }

            data.ageInDays = Object.keys(ages).map(ageId => {
                if (ages[ageId].selected) {
                    switch (ageId) {
                        case "j-0":
                            return 0;
                        case "j-1":
                            return 1;
                        case "j-2":
                            return 2;
                        case "j-3":
                            return 3;
                        default:
                            return 4;
                    }
                }
            }).filter(age => undefined !== age && null !== age)

            let orderTypeArray = Object.keys(orderTypes).filter(type => true === orderTypes[type].selected)

            if (1 === orderTypeArray.length) {
                if ("multi" === orderTypeArray[0]) {
                    data.isMulti = true
                } else {
                    data.isMulti = false
                }
            }

            update(editableModel, data).then((response) => {
                history.push({
                    pathname: WMSRoutes.MISSION_MODEL_LIST,
                    state: {hasChanged: response.name},
                    action: "PUSH"
                })
            }).catch(() => {
                setOpenErrorToast(true)
            }).finally(() => setLoading(false))
            return;
        }

        if (isModel) {
            const data = {
                auto: isModelAuto,
                name: missionName,
                inventory: currentInventory,
                places: Object.fromEntries(Object.entries(selectedPlaces).filter(([k]) => k !== "all")),
                orderTypes: orderTypes,
                providers: Object.fromEntries(Object.entries(selectedProviders).filter(([k]) => k !== "all")),
                quantity: quantity,
                shippingMethods: Object.fromEntries(Object.entries(selectedShippingMethods).filter(([k]) => k !== "all")),
                priorityRules: selectedPriorityRule,
                age: ages
            }

            createNewModel(data).then(() => {
                handleResetForm()
                setMissionName("")
                setOpenToast(true)
            }).catch(() => {
                setOpenErrorToast(true)
            }).finally(() => setLoading(false))
        } else {
            const data = {
                name: missionName,
                inventory: currentInventory,
                places: places,
                providers: selectedProviders,
                runner: selectedRunners,
                quantity: quantity,
                items: selectedItems,
                priorityRules: selectedPriorityRule["value"]
            }

            createNewMission(data).then(() => {
                setLoading(false)
                if (selectedRunners.id === currentMember.id) {
                    history.push(`${WMSRoutes.PICKING}`, {taskCreated: true})
                } else {
                    setOpenToast(true)
                }
            }).catch(() => {
                setLoading(false)
                setOpenErrorToast(true)
            })
        }
    }

    const handleIsModel = () => {
        setIsModel(prev => !prev)
    }

    const handleIsModelAuto = () => {
        setIsModelAuto(prev => !prev)
    }

    const handleCloseDrawer = () => {
        setOpenDrawer(null)
    }

    const getDrawerTitle = () => {
        if (!openDrawer) {
            return
        }

        switch (openDrawer) {
            case openDrawerType.PROVIDER:
                return <FormattedMessage id={`wms.newPickingMission.${drawerTypeTraductionKey.PROVIDER}Drawer.title`}/>
            case openDrawerType.ZONE:
                return <FormattedMessage id={`wms.newPickingMission.${drawerTypeTraductionKey.ZONE}Drawer.title`}/>
            case openDrawerType.CARRIER:
                return <FormattedMessage id={`wms.newPickingMission.${drawerTypeTraductionKey.CARRIER}Drawer.title`}/>
            case openDrawerType.PICKER:
                return <FormattedMessage id={`wms.newPickingMission.${drawerTypeTraductionKey.PICKER}Drawer.title`}/>
            default:
                return "";
        }
    }

    const getDrawerSubtitle = () => {
        if (!openDrawer) {
            return
        }

        switch (openDrawer) {
            case openDrawerType.PROVIDER:
                return <FormattedMessage id={`wms.newPickingMission.${drawerTypeTraductionKey.PROVIDER}Drawer.subtitle`}/>
            case openDrawerType.ZONE:
                return <FormattedMessage id={`wms.newPickingMission.${drawerTypeTraductionKey.ZONE}Drawer.subtitle`}/>
            case openDrawerType.CARRIER:
                return <FormattedMessage id={`wms.newPickingMission.${drawerTypeTraductionKey.CARRIER}Drawer.subtitle`}/>
            case openDrawerType.PICKER:
                return <FormattedMessage id={`wms.newPickingMission.${drawerTypeTraductionKey.PICKER}Drawer.subtitle`}/>
            default:
                return "";
        }
    }

    const getDrawerContent = () => {
        if (!openDrawer) {
            return
        }

        switch (openDrawer) {
            case openDrawerType.PROVIDER:
                if (providers) {
                    return (
                        <DrawerContent
                            open={openDrawerType}
                            searchString={searchString}
                            contents={providers}
                            handleSelectContent={handleSelectProvider}
                            isModel={isModel}
                            tradKey={drawerTypeTraductionKey.PROVIDER}
                        />
                    )
                }
                break;

            case openDrawerType.ZONE:
                return (
                    <DrawerContent
                        open={openDrawerType}
                        searchString={searchString}
                        contents={places}
                        handleSelectContent={handleSelectPlace}
                        isModel={isModel}
                        tradKey={drawerTypeTraductionKey.ZONE}
                    />
                )
            case openDrawerType.CARRIER:
                return (
                    <DrawerContent
                        open={openDrawerType}
                        searchString={searchString}
                        contents={shippingMethods}
                        handleSelectContent={handleSelectShippingMethods}
                        isModel={isModel}
                        tradKey={drawerTypeTraductionKey.CARRIER}
                    />
                )
            case openDrawerType.PICKER:
                return (
                    <DrawerContent
                        open={openDrawerType}
                        searchString={searchString}
                        contents={runners}
                        handleSelectContent={handleSelectRunners}
                        isModel={isModel}
                        tradKey={drawerTypeTraductionKey.PICKER}
                    />
                )
        }
    }

    const getSearchBarPlaceholder = () => {
        if (!openDrawer) {
            return
        }

        switch (openDrawer) {
            case openDrawerType.CARRIER:
                return `wms.newPickingMission.${drawerTypeTraductionKey.CARRIER}Drawer.searchBarPlaceholder`
            case openDrawerType.PICKER:
                return `wms.newPickingMission.${drawerTypeTraductionKey.PICKER}Drawer.searchBarPlaceholder`
            case openDrawerType.PROVIDER:
                return `wms.newPickingMission.${drawerTypeTraductionKey.PROVIDER}Drawer.searchBarPlaceholder`
            case openDrawerType.ZONE:
                return `wms.newPickingMission.${drawerTypeTraductionKey.ZONE}Drawer.searchBarPlaceholder`
        }
    }

    const handleCancel = () => {
        const resetSelected = (obj) => Object.fromEntries(
            Object.entries(obj).map(([key, item]) => [key, {...item, selected: false}])
        )

        setMissionName("")
        setSearchString("")
        setSelectedRunners([])

        setSelectedProviders({all: {...selectedProviders.all, selected: true}})
        setSelectedShippingMethods({all: {...selectedShippingMethods.all, selected: true}})
        setSelectedPlaces({all: {...selectedPlaces.all, selected: true}})

        setProviders(resetSelected(providers))
        setShippingMethods(resetSelected(shippingMethods))
        setPlaces(resetSelected(places))
        setRunners(resetSelected(runners))
        setAges(resetSelected(ages))
        setOrderTypes(resetSelected(orderTypes))
    }

    useEffect(() => {
        let totalItems = formData.allItems
        setIsValid(false)

        if (places) {
            let tempPlaces = getObjectData(places)
            if (priorityRules.value === wmsPriorityRule.PLACE_ITEMS) {
                tempPlaces = orderByItemsCount(tempPlaces, "count")
            }
            let tempSelectedPlacesItem = []
            tempPlaces.map(place => {
                if (place.selected) {
                    setIsValid(true)
                    place.items.map(item => {
                        if (!tempSelectedPlacesItem.includes(item)) {
                            tempSelectedPlacesItem.push(item)
                        }
                    })
                }
            })
            if (tempSelectedPlacesItem.length > 0) {
                totalItems = filterItem(totalItems, tempSelectedPlacesItem)
            }
        }

        if (selectedProviders) {
            let tempProviders = getObjectData(selectedProviders)
            if (priorityRules.value === wmsPriorityRule.RETAILER_ITEMS) {
                tempProviders = orderByItemsCount(tempProviders, "count")
            }
            let tempProvidersItem = []
            tempProviders.map(provider => {
                if (provider.selected) {
                    if (provider.items.length > 0) {
                        setIsValid(true)
                    }
                    provider.items.map(item => {
                        if (!tempProvidersItem.includes(item)) {
                            tempProvidersItem.push(item)
                        }
                    })
                }
            })
            if (tempProvidersItem.length > 0) {
                totalItems = filterItem(totalItems, tempProvidersItem)
            }
        }

        if (orderTypes) {
            const tempOrderTypes = getObjectData(orderTypes)
            let tempSelectedOrderTypesItem = []
            tempOrderTypes.map(orderType => {
                if (orderType.selected) {
                    setIsValid(true)
                    orderType.items.map(item => {
                        if (!tempSelectedOrderTypesItem.includes(item)) {
                            tempSelectedOrderTypesItem.push(item)
                        }
                    })
                }
            })
            if (tempSelectedOrderTypesItem.length > 0) {
                totalItems = filterItem(totalItems, tempSelectedOrderTypesItem)
            }
        }

        if (shippingMethods) {
            const tempShippingMethods = getObjectData(shippingMethods)
            let tempSelectedShippingMethodsItems = []
            tempShippingMethods.map(shippingMethod => {
                if (shippingMethod.selected) {
                    setIsValid(true)
                    shippingMethod.items.map(item => {
                        if (!tempSelectedShippingMethodsItems.includes(item)) {
                            tempSelectedShippingMethodsItems.push(item)
                        }
                    })
                }
            })
            if (tempSelectedShippingMethodsItems.length > 0) {
                totalItems = filterItem(totalItems, tempSelectedShippingMethodsItems)
            }
        }

        if (ages) {
            const tempAges = getObjectData(ages)
            let tempAgesItems = []
            tempAges.map(age => {
                if (age.selected) {
                    setIsValid(true)
                    age.items.map(item => {
                        if (!tempAgesItems.includes(item)) {
                            tempAgesItems.push(item)
                        }
                    })
                }
            })
            if (tempAgesItems.length > 0) {
                totalItems = filterItem(totalItems, tempAgesItems)
            }
        }


        if (totalItems.length > quantity) {
            setProductCount(quantity)
            if (priorityRules.value === wmsPriorityRule.PLACE_ITEMS) {
                const tempPlaces = getObjectData(places)
                let maxItemPlace = {count: 0}
                tempPlaces.map(place => {
                    if (place.count > maxItemPlace.count) {
                        maxItemPlace = place
                    }
                })
                totalItems = totalItems.filter
            }

            if (priorityRules.value === wmsPriorityRule.RETAILER_ITEMS) {

            }
            totalItems = totalItems.slice(0, quantity)
        }
        if (missionName.length < 1) {
            setIsValid(false)
        }

        if (!isModel && selectedRunners.length < 1) {
            setIsValid(false)
        }

        if (!/^\d+$/.test(quantity)) {
            setIsValid(false)
        }

        setProductCount(totalItems.length)
        setSelectedItems(totalItems)
    }, [selectedPriorityRule, selectedRunners, selectedProviders, places, orderTypes, ages, shippingMethods, quantity, missionName]);

    useEffect(() => {
        let places = formatNoWmsPlaces(formData.places)
        let orderType = formData.orderType
        let shippingMethods = formData.shippingMethods
        let priorityRules = getPriorityRulesForForm()
        let selectedPriorityRule = priorityRules.find(rule => rule.value === wmsPriorityRule.FIFO)
        let ages = formData.age

        setRunners(formData.members)

        if (isEdit && editableModel) {
            setMissionName(editableModel.name)

            selectedPriorityRule = priorityRules.find(rule => rule.value === editableModel.priorityOrder)
            if (0 < editableModel.wmsPlaces.length) {
                Object.keys(places).map(placeId => {
                    if (editableModel.wmsPlaces.some(plc => plc.id === placeId)) {
                        places[placeId].selected = true
                    }
                })
            }

            if (editableModel.noWmsPlaces) {
                places.noWmsPlaces.selected = true
            }

            if (undefined !== editableModel.isMulti && null !== editableModel.isMulti) {
                if (true === editableModel.isMulti) {
                    orderType.multi.selected = true
                } else if (false === editableModel.isMulti) {
                    orderType.mono.selected = true
                }
            }

            if (0 < editableModel.shippingMethods.length) {
                Object.keys(shippingMethods).map(shippingMethodId => {
                    if (editableModel.shippingMethods.some(method => method.id === shippingMethodId)) {
                        shippingMethods[shippingMethodId].selected = true
                    }
                })
            }

            if (0 < editableModel.ageInDays.length) {
                editableModel.ageInDays.forEach(ageInDay => {
                    if (Object.keys(ages).some(ageValue => ageValue === PickingMissionModelAgeInDays[ageInDay])) {
                        ages[PickingMissionModelAgeInDays[ageInDay]].selected = true
                    }

                })
            }

            setQuantity(editableModel.maxItems)
        }

        let initProviderToggle = getInitProvider()
        let initShippingMethodToggle = getInitShippingMethod()
        let initPlaceToggle = getInitPlace()

        setSelectedProviders(initProviderToggle)

        setSelectedShippingMethods(initShippingMethodToggle)

        setSelectedPlaces(initPlaceToggle)

        setProviders(formData.providers)

        setAges(ages)
        setPlaces(places)
        setOrderTypes(orderType)
        setShippingMethods(shippingMethods)
        setSelectedPriorityRule(selectedPriorityRule)
        setPriorityRules(getPriorityRulesForForm())
    }, [formData, isModel, isEdit, editableModel]);

    useEffect(() => {
        if (!isEdit && currentOrganization?.wmsDefaultPickingMissionItemLimit && currentOrganization.wmsDefaultPickingMissionItemLimit > 0)
            setQuantity(currentOrganization.wmsDefaultPickingMissionItemLimit)
    }, [currentOrganization]);

    useEffect(() => {
        if (!hasAutoSelectedRunner.current && currentMember && runners && formData.members[currentMember.id]) {
            hasAutoSelectedRunner.current = true;
            handleSelectRunners(formData.members[currentMember.id])
        }
    }, [currentMember, formData, runners]);

    return (
        <Grid
            container
            direction={isMobile ? 'column' : 'row'}
            flexWrap={'nowrap'}
            gap={'16px'}
            sx={{flex: 1, minHeight: 0}}
        >
            {openDrawer && !isMobile && (
                <RightDrawerDesktop
                    open={!!openDrawer}
                    onClose={handleCloseDrawer}
                    title={getDrawerTitle()}
                    subtitle={getDrawerSubtitle()}
                    underTitle={
                        <SearchBar
                            customPlaceholder={getSearchBarPlaceholder()}
                            onChange={(value) => setSearchString(value)}
                            style={{marginBottom: "24px"}}
                        />
                    }
                >
                    {getDrawerContent()}
                </RightDrawerDesktop>
            )}

            {openDrawer && isMobile && (
                <BottomDrawer
                    open={!!openDrawer}
                    onClose={handleCloseDrawer}
                    title={getDrawerTitle()}
                    subtitle={getDrawerSubtitle()}
                    noHeightLimit
                    openMaxHeight
                    underTitle={
                        <SearchBar
                            customPlaceholder={"wms.newPickingMission.providerDrawer.searchBarPlaceholder"}
                            onChange={(value) => setSearchString(value)}
                        />
                    }
                >
                    {getDrawerContent()}
                </BottomDrawer>
            )}

            <Card
                variant="outlined"
                sx={{
                    border: 'none',
                    flex: isMobile ? 'unset' : '3 1 0',
                    height: isMobile ? 'unset' : 'fit-content'
                }}
            >
                <CardContent sx={{overflowY: "auto"}}>
                    <Grid
                        container
                        direction={'column'}
                        gap={'16px'}
                    >
                        <Grid
                            container
                            direction={"column"}
                            gap={"8px"}
                        >
                            <span
                                style={{
                                    fontSize: "20px",
                                    color: blueColor,
                                    fontWeight: 600,
                                    marginBottom: "32px"
                                }}
                            >
                                {isModel && (
                                    <FormattedMessage id={"wms.newPickingMissionModel.name.title"}/>
                                )}
                                {false === isModel && (
                                    <FormattedMessage id={"wms.newPickingMission.name.title"}/>
                                )}
                            </span>

                            <Label htmlFor={`name`} required={true}>
                                {isModel ? (
                                    <FormattedMessage id={"wms.newPickingMissionModel.name.title"}/>
                                ) : (
                                    <FormattedMessage id={"wms.newPickingMission.name.title"}/>
                                )}
                            </Label>
                            <InputTextField
                                value={missionName}
                                placeholder
                                onChange={(event) => handleChangeMissionName(event.target.value)}
                            />
                        </Grid>

                        <Grid
                            container
                            gap={"8px"}
                            alignContent={"center"}
                            flexWrap={'nowrap'}
                            onClick={isEdit ? () => {
                            } : handleIsModel}
                        >
                            <CustomSwitch checked={isModel} disabled={isEdit}/>
                            <span style={{fontSize: "14px", height: "fit-content", margin: "auto 0"}}>
                                <FormattedMessage id={"wms.newPickingMission.checkbox.label"}/>
                            </span>
                        </Grid>

                        {isModel && (
                            <Grid
                                container
                                gap={"8px"}
                                alignContent={"center"}
                                flexWrap={'nowrap'}
                                onClick={handleIsModelAuto}
                            >
                                <CustomSwitch checked={isModelAuto} disabled={!isModel}/>
                                <span style={{fontSize: "14px", height: "fit-content", margin: "auto 0"}}>
                                        <FormattedMessage id={"wms.newPickingMission.isAuto.checkbox.label"}/>
                                    </span>
                            </Grid>
                        )}

                        <Grid
                            container
                            direction={"column"}
                            gap={"8px"}
                            sx={{marginTop: '48px'}}
                        >
                            <span
                                style={{
                                    fontSize: "20px",
                                    color: blueColor,
                                    fontWeight: 600,
                                    marginBottom: '32px'
                                }}
                            >
                                <FormattedMessage id={"wms.newPickingMission.priorityRules.title"}/>
                            </span>

                            <SelectTitle titleTranslationKey={"wms.newPickingMission.priorityRules.label"}/>
                            <RadioGroup
                                alignListWithButton
                                selectedValueLabel={selectedPriorityRule?.label}
                                value={selectedPriorityRule?.value}
                                onChange={(event) => {
                                    handleSelectPriorityRules(event.currentTarget.value)
                                }}
                            >
                                {priorityRules.map((rule, index) => (
                                    <FormControlLabel
                                        key={index}
                                        value={rule.value}
                                        label={rule.label}
                                    />
                                ))}
                            </RadioGroup>
                        </Grid>

                        {!isModel && (
                            <Grid
                                container
                                direction={"column"}
                                gap={"8px"}
                                sx={{marginTop: '48px'}}
                            >
                            <span
                                style={{
                                    fontSize: "20px",
                                    color: blueColor,
                                    fontWeight: 600,
                                    marginBottom: '32px'
                                }}
                            >
                                <FormattedMessage id={"wms.newPickingMission.selectRunner.title"}/>
                            </span>
                                <Grid
                                    container
                                    direction={"column"}
                                >
                                    <SelectTitle required={true} titleTranslationKey={"wms.newPickingMission.members"}/>
                                    <Grid
                                        container
                                        direction={'row'}
                                        flexWrap={"nowrap"}
                                        gap={"8px"}
                                    >
                                        <Grid item flex={1}>
                                            <InputTextField
                                                fullWidth
                                                hasAdornment
                                                value={selectedRunners?.name ?? ""}
                                                placeholder={intl.formatMessage({id: "wms.newPickingMission.addRunner.placeholder"})}
                                                onClick={() => setOpenDrawer(openDrawerType.PICKER)}
                                                InputProps={{
                                                    endAdornment: <InputAdornment position="end"><span style={{rotate: "270deg"}}><ArrowDownIcon/></span></InputAdornment>,
                                                    readOnly: true,
                                                }}
                                            />

                                        </Grid>
                                    </Grid>
                                </Grid>
                            </Grid>
                        )}
                    </Grid>
                </CardContent>
            </Card>

            <Card
                variant="outlined"
                sx={{
                    border: 'none',
                    flex: isMobile ? 'unset' : '7 1 0',
                    overflowY: isMobile ? 'unset' : 'auto'
                }}
            >
                <CardContent>
                    <Grid container direction={"column"} gap={"48px"}>
                        {openToast && (
                            <Toast
                                open={openToast}
                                handleClose={() => setOpenToast(false)}
                                isDesktop={!isMobile}
                                isTop={!isMobile}
                                customTimeout={2000}
                                icon={<img style={{height: '20px', width: '20px'}} src={ValidatedIcon}
                                           alt={"validated-icon"}/>}
                                title={<FormattedMessage id={"wms.newPickingMission.successToast.title"}/>}
                            />
                        )}

                        {openErrorToast && (
                            <Toast
                                open={openErrorToast}
                                handleClose={() => setOpenErrorToast(false)}
                                isDesktop={!isMobile}
                                isTop={!isMobile}
                                customTimeout={2000}
                                icon={<img style={{height: '20px', width: '20px'}} src={ErrorIcon}
                                           alt={"error-icon"}/>}
                                title={<FormattedMessage id={"wms.newPickingMission.errorToast.title"}/>}
                            />
                        )}

                        <Grid container direction={"column"} gap={"32px"}>
                            <Grid container direction={"column"} gap={"24px"}>
                                <span
                                    style={{
                                        fontSize: "20px",
                                        color: blueColor,
                                        fontWeight: 600,
                                        marginBottom: "8px"
                                    }}
                                >
                                    <FormattedMessage id={"wms.newPickingMission.pickingChoice.title"}/>
                                </span>

                                {places && (
                                    <FormToggleSelection
                                        data={selectedPlaces}
                                        title={<FormattedMessage id={"wms.newPickingMission.placeChoice"}/>}
                                        identity={"name"}
                                        count={"count"}
                                        handleSelectValue={handleSelectPlace}
                                        handleAddValue={() => setOpenDrawer(openDrawerType.ZONE)}
                                        isNotFinal
                                        isModel={isModel}
                                        getObjectData={getObjectData}
                                        orderByItemsCount={orderByItemsCount}
                                    />
                                )}

                                {orderTypes && (
                                    <FormToggleSelection
                                        data={orderTypes}
                                        title={<FormattedMessage id={"wms.newPickingMission.orderTypes"}/>}
                                        identity={"name"}
                                        count={"count"}
                                        handleSelectValue={handleSelectOrderType}
                                        isModel={isModel}
                                        getObjectData={getObjectData}
                                        orderByItemsCount={orderByItemsCount}
                                    />
                                )}

                                {shippingMethods && (
                                    <FormToggleSelection
                                        data={selectedShippingMethods}
                                        title={<FormattedMessage id={"wms.newPickingMission.shippingMethods"}/>}
                                        identity={"name"}
                                        count={"count"}
                                        icon={"logo"}
                                        handleSelectValue={handleSelectShippingMethods}
                                        isNotFinal
                                        handleAddValue={() => setOpenDrawer(openDrawerType.CARRIER)}
                                        isModel={isModel}
                                        getObjectData={getObjectData}
                                        orderByItemsCount={orderByItemsCount}
                                    />
                                )}

                                {selectedProviders && (
                                    <FormToggleSelection
                                        data={selectedProviders}
                                        title={<FormattedMessage id={"wms.newPickingMission.providers"}/>}
                                        identity={"name"}
                                        count={"count"}
                                        handleSelectValue={handleSelectProvider}
                                        isNotFinal
                                        handleAddValue={() => setOpenDrawer(openDrawerType.PROVIDER)}
                                        isModel={isModel}
                                        getObjectData={getObjectData}
                                        orderByItemsCount={orderByItemsCount}
                                    />
                                )}

                                {ages && (
                                    <FormToggleSelection
                                        data={ages}
                                        title={<FormattedMessage id={"wms.newPickingMission.age"}/>}
                                        identity={"name"}
                                        count={"count"}
                                        handleSelectValue={handleSelectAge}
                                        isModel={isModel}
                                        getObjectData={getObjectData}
                                    />
                                )}

                                <Grid container direction={"column"} sx={{width: isMobile ? '100%' : desktopMaxWidth}}
                                      gap={"8px"}>
                        <span
                            style={{
                                fontWeight: 600,
                                fontSize: "12px"
                            }}
                        >
                            <FormattedMessage id={"wms.newPickingMission.quantity"}/>
                        </span>
                                    <TextField
                                        type={"number"}
                                        inputProps={{min: 1, step: 1}}
                                        value={quantity}
                                        onChange={(event) => handleChangeQuantity(event.target.value)}
                                    />
                                    {numberProductError && (
                                        <span style={{color: red500}}><FormattedMessage
                                            id={"wms.newPickingMission.productNumberError"}/></span>
                                    )}
                                </Grid>
                            </Grid>
                        </Grid>
                        <footer style={{position: "sticky", bottom: 0,}}>
                            <Grid container direction={"row"} wrap={"nowrap"} justifyContent={"end"} gap={"16px"}>
                                <CustomButton color={"default"} onClick={() => handleCancel()}>
                                    <FormattedMessage id={"wms.newPickingMission.cancelButton"}/>
                                </CustomButton>
                                <CustomButton
                                    onClick={handleValid}
                                    disabled={!isValid || loading}>
                        <span>
                            {isModel ?
                                <FormattedMessage id={"wms.newPickingMission.validButton.missionModel"}/> :
                                <FormattedMessage id={"wms.newPickingMission.validButton"}/>}
                            <br/>
                            ({productCount} <FormattedMessage id={"wms.newPickingMission.productCountLabel"}/>)
                        </span>
                                </CustomButton>
                            </Grid>
                        </footer>
                    </Grid>
                </CardContent>
            </Card>
        </Grid>

    );
}

export default CreatePickingMissionForm;
